import PropTypes from 'prop-types';

function SideBySideSection({ title, diff }) {
	const added = diff?.added || [];
	const removed = diff?.removed || [];
	const modified = diff?.modified || [];
	if (added.length === 0 && removed.length === 0 && modified.length === 0) return null;

	return (
		<div className="dsv-compare__sheet" data-testid={`dsv-compare-section-${title}`}>
			<div className="dsv-compare__sheet-title">{title}</div>
			{removed.map((e) => (
				<div key={`r-${e.key}`} className="dsv-compare__kv">
					<span className="dsv-compare__gutter dsv-compare__gutter--r">−</span>
					<span className="dsv-compare__kv-key">{e.key}</span>
					<span><span className="dsv-compare__value--before">{e.before}</span></span>
					<span />
				</div>
			))}
			{modified.map((e) => (
				<div key={`m-${e.key}`} className="dsv-compare__kv">
					<span className="dsv-compare__gutter dsv-compare__gutter--m">~</span>
					<span className="dsv-compare__kv-key">{e.key}</span>
					<span><span className="dsv-compare__value--before">{e.before}</span></span>
					<span><span className="dsv-compare__value--after">{e.after}</span></span>
				</div>
			))}
			{added.map((e) => (
				<div key={`a-${e.key}`} className="dsv-compare__kv">
					<span className="dsv-compare__gutter dsv-compare__gutter--a">+</span>
					<span className="dsv-compare__kv-key">{e.key}</span>
					<span />
					<span><span className="dsv-compare__value--after">{e.after}</span></span>
				</div>
			))}
		</div>
	);
}

SideBySideSection.propTypes = {
	title: PropTypes.string,
	diff: PropTypes.shape({ added: PropTypes.array, removed: PropTypes.array, modified: PropTypes.array }),
};

export default SideBySideSection;
